module.exports = __webpack_public_path__ + "static/media/6.c2f0f3f8.mp4";